import Iframe from '@commons/components/Iframe';
import type { DrupalBlock, DrupalText } from '@commons/types/drupal';

// Type definition for Aspect ratio property values.

type AspectRatio = '1 / 1' | '16 / 9' | 'custom';

// Type definition for Iframe block props.

type Props = DrupalBlock<{
  aspectRatio?: AspectRatio;
  height?: number;
  source?: DrupalText;
}>;

/**
 * Iframe block component.
 */

const IframeBlock = ({ content }: Props) => {
  const { source, height } = content;

  const aspectRatio = content.aspectRatio || '1 / 1';

  // Convert aspectRatio to a CSS-friendly format
  const aspectRatioValue = aspectRatio !== 'custom' ? aspectRatio.replace('_', ' / ') : undefined;

  const customHeight = aspectRatio === 'custom' ? height : undefined;

  return (
    <Iframe
      theme="white"
      height={customHeight}
      source={source?.value || '#'}
      aspectRatio={aspectRatioValue}
    />
  );
};

export default IframeBlock;
